export default "__VITE_ASSET__DyVZdAVe__"